export default __webpack_public_path__ + "static/media/moodle-negative.970df2eb.svg";